import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [],
  exports: [RouterModule],
})
export class CoreRoutingModule { }
